<template>
  <div class="page">
    <div style="display:none" v-title>医生中心</div>
    <template v-if="!noRights">
      <h1>个人资料</h1>
      <div class="register-favor" :style="avatar"></div>
      <div class="register-form">
        <div class="input-item">
          <span class="input-item-text">医院名称</span>
          <input type="text" v-model="hosName" placeholder="请输入医院名称" readonly />
        </div>
        <div class="input-item">
          <span class="input-item-text">医院地址</span>
          <input type="text" v-model="hosAddress" placeholder="请输入医院地址" readonly />
        </div>
        <div class="input-item">
          <span class="input-item-text">医院电话</span>
          <input type="text" v-model="hosPhone" placeholder="请输入医院电话" readonly />
        </div>
        <div class="input-item">
          <span class="input-item-text">科室</span>
          <input type="text" v-model="section" placeholder="请输入科室" />
        </div>
        <div class="input-item">
          <span class="input-item-text">姓名</span>
          <input type="text" v-model="name" placeholder="请输入姓名" />
        </div>

        <div class="input-item">
          <span class="input-item-text">职称</span>
          <input type="text" v-model="title" placeholder="请输入职称" />
        </div>
        <div class="input-item">
          <span class="input-item-text">年龄</span>
          <input type="text" v-model="age" placeholder="请输入年龄" />
        </div>
        <div class="input-item">
          <span class="input-item-text">性别</span>
          <div class="input-other">
            <span @click="selectSex(1)">
              <span class="input-radio-item" :class="{'input-radio-item-active': sex === 1}"></span> 男
            </span>
            <span @click="selectSex(2)" class="ml-40">
              <span class="input-radio-item" @click="selectSex(2)" :class="{'input-radio-item-active': sex === 2}"></span> 女
            </span>
          </div>
        </div>
        <div class="input-item">
          <span class="input-item-text">手机</span>
          <input type="text" v-model="phone" placeholder="请输入手机"  readonly/>
        </div>
        <div class="input-item">
          <span class="input-item-text">仪器编号</span>
          <input type="text" v-model="product" placeholder="未知" readonly/>
        </div>
        <div class="input-item">
          <span class="input-item-text">专业特长</span>
          <textarea v-model="strength" placeholder="请输入专业特长"></textarea>
        </div>
        <div class="input-item">
          <span class="input-item-text">临床经验</span>
          <textarea v-model="experience" placeholder="请输入临床经验"></textarea>
        </div>
        <div class="register-btn" @click="toEditUser">修改</div>
      </div>
    </template>
    <template v-if="noRights">
      <div class="no-rights">参数错误！</div>
    </template>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { validateEmpty } from '../utils/validator'
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
export default {
  name: 'UserInfo',
  data () {
    return {
      sex: 1,
      detail: {},
      section: '',
      title: '',
      name: '',
      phone: '',
      strength: '',
      experience: '',
      age: '',
      hosName: '',
      hosAddress: '',
      hosPhone: '',
      comcode: '',
      noRights: false,
      product: '',
      avatarUrl: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    avatar: function () {
      return this.avatarUrl ? 'background-image:url("' + this.avatarUrl + '")' : ''
    }
  },
  created () {
    let secret = 'tL92QZVP5WS1b7X8'
    let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
    let formet = 'json'
    let serial = Date.parse(new Date()) / 1000
    let ver = '1.0'
    let comcode = this.$route.query.comcode

    let doctorid = this.$route.query.doctorid
    let sign1 = md5(secret + appkey + comcode + formet + serial + ver)
    let sign = md5(secret + appkey + doctorid + formet + serial + ver)
    let params1 = {
      serial: serial,
      ver: ver,
      formet: formet,
      secret: secret,
      appkey: appkey,
      sign: sign1,
      comcode: comcode
    }
    let params = {
      serial: serial,
      ver: ver,
      formet: formet,
      secret: secret,
      appkey: appkey,
      sign: sign,
      doctorid: doctorid
    }
    // 公司信息
    this.$axios.get('/Index/Doctor/CompanyInfo', { params: params1 }).then((response) => {
      if (response.data.code !== 1000) {
        this.noRights = true
      } else {
        this.hosName = response.data.data[0].name
        this.hosAddress = response.data.data[0].address || '无'
        this.hosPhone = response.data.data[0].phone || '无'
      }
    }).catch(function () {})
    // 用户信息
    this.$axios.get('/Index/Doctor/Info', { params: params }).then((response) => {
      this.detail = response.data.data[0]
      this.section = this.detail.section
      this.name = this.detail.name
      this.title = this.detail.title || ''
      this.sex = this.detail.sex
      this.phone = this.detail.phone
      this.age = this.detail.age
      this.avatarUrl = this.detail.avatar
      this.strength = this.detail.strength
      this.product = this.detail.product
      this.experience = this.detail.experience
    }).catch(function () {})
  },
  methods: {
    selectSex (sex) {
      this.sex = sex
    },
    toEditUser () {
      if (validateEmpty(this.$route.query.doctorid)) {
        Toast({
          message: '缺少医生ID！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.name)) {
        Toast({
          message: '请输入姓名！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.section)) {
        Toast({
          message: '请输入所属科室！',
          duration: 1500
        })
        return
      }
      if (isNaN(this.age) || this.age < 1 || this.age > 100) {
        Toast({
          message: '请输入正确的年龄！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.title)) {
        Toast({
          message: '请输入所属职称！',
          duration: 1500
        })
        return
      }
      let secret = 'tL92QZVP5WS1b7X8'
      let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
      let formet = 'json'
      let serial = Date.parse(new Date()) / 1000
      let ver = '1.0'

      let doctorid = this.$route.query.doctorid
      let age = this.age
      let experience = this.experience
      let name = this.name
      let phone = this.phone
      let section = this.section
      let sex = this.sex
      let strength = this.strength
      let title = this.title
      let sign = md5(secret + age + appkey + doctorid + experience + formet + name + phone + section + serial + sex + strength + title + ver)
      let params = {
        serial: serial,
        ver: ver,
        formet: formet,
        secret: secret,
        appkey: appkey,
        sign: sign,
        doctorid: doctorid,
        age: this.age,
        experience: this.experience,
        name: this.name,
        phone: this.phone,
        section: this.section,
        sex: this.sex,
        strength: this.strength,
        title: this.title
      }
      this.$axios.get('/Index/Doctor/Edit/', { params: params }).then((response) => {
        if (response.data.code === 1000) {
          Toast({
            message: '修改个人信息成功！',
            duration: 1500
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500)
        } else {
          Toast({
            message: '修改个人信息失败！',
            duration: 1500
          })
        }
      }).catch(function () {})
    }
  }
}
</script>
<style lang="stylus" scoped>
.page
  width 720px
  margin 0 auto
  background-color #fafafa
  h1
    font-size: 35px; /*px*/
    color #333333
    padding-top 38px
    margin-bottom 40px
    padding-left 30px
.register-favor
  margin 0 auto
  width 232px
  height 232px
  background-size 232px auto
  background-image url('../assets/images/no-user.png')
  background-position center center
  font-size: 24px; /*px*/
  background-repeat no-repeat
.register-form
  width 100%
  padding 56px 30px 60px 30px
  .input-item
    margin-bottom 50px
    textarea
      width 465px
      height 261px
      border-radius 5px
      border: 1px solid #999899; /*no*/
      vertical-align text-top
      margin-top -16px
      margin-left 10px
      font-size: 29px; /*px*/
      padding 15px
  .input-item-text
    position relative
    display inline-block
    width 162px
    margin-right 12px
    font-size: 33px; /*px*/
    color #333333
    text-align justify
    line-height 0
    text-align-last justify
    &:after
      position absolute
      right -34px
      top 0
      content '：'
      font-size: 33px; /*px*/
      color #333333
  input
    border-bottom: 1px solid #eaeaea; /*no*/
    width 475px
    height 46px
    padding-left 30px
    line-height 46px
    font-size: 29px; /*px*/
    background-color transparent
    color #666
  .input-other
    display inline-block
    width 475px
    height 46px
    padding-left 30px
    line-height 46px
    font-size: 29px; /*px*/
    // border-bottom: 1px solid #eaeaea; /*no*/
    // padding-bottom 2px
    color #666
  .input-radio-item
    display inline-block
    width 43px
    height 43px
    vertical-align middle
    border: 1px solid #999899; /*no*/
    border-radius 43px
    margin-right 10px
  .input-radio-item-active
      border none
      background-image url('../assets/images/icon-radio.png')
      background-size 43px 43px
.register-btn
  margin 0 auto
  width 664px
  height 86px
  line-height 86px
  text-align center
  font-size: 35px; /*px*/
  letter-spacing 7px
  color #ffffff
  background-color #c4c4c4
  border-radius 5px
  background-image url('../assets/images/l-btn.png')
  background-size 664px 86px
  background-repeat no-repeat
  font-weight 300
.ml-40
  margin-left 40px
</style>



// WEBPACK FOOTER //
// src/pages/UserInfo.vue